import { Link, createFileRoute, useRouterState } from '@tanstack/react-router'
import { PreprocessingPage } from '@/features/model-training'

// `datasets_`: under the Datasets address without being rendered inside the Datasets page.
export const Route = createFileRoute('/app/model-training/datasets_/$datasetId/preprocessing')({
  component: PreprocessingRoute,
})

function PreprocessingRoute() {
  const { datasetId } = Route.useParams()
  const navigate = Route.useNavigate()
  // Handed on by the Feature Selection; absent after a reload or when the address was opened directly.
  const listSearch = useRouterState({ select: (state) => state.location.state.datasetList }) ?? {}

  return (
    <PreprocessingPage
      datasetId={datasetId}
      onPrevious={() => {
        void navigate({
          to: '/app/model-training/datasets/$datasetId/features',
          params: { datasetId },
          state: { datasetList: listSearch },
        })
      }}
      onNext={() => {
        void navigate({
          to: '/app/model-training/datasets/$datasetId/train',
          params: { datasetId },
          state: { datasetList: listSearch },
        })
      }}
      onBackToDatasets={() => {
        void navigate({ to: '/app/model-training/datasets', search: listSearch })
      }}
      renderDatasetsLink={(content, className) => (
        <Link to="/app/model-training/datasets" search={listSearch} className={className}>
          {content}
        </Link>
      )}
      renderPreviewLink={(content, className) => (
        <Link
          to="/app/model-training/datasets/$datasetId/preview"
          params={{ datasetId }}
          state={{ datasetList: listSearch }}
          className={className}
        >
          {content}
        </Link>
      )}
      renderFeaturesLink={(content, className) => (
        <Link
          to="/app/model-training/datasets/$datasetId/features"
          params={{ datasetId }}
          state={{ datasetList: listSearch }}
          className={className}
        >
          {content}
        </Link>
      )}
    />
  )
}
